import Swiper, {Navigation, Lazy} from "swiper";
import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const";
import getPublicationSlides from "./get-publications";

const NUMBER_OF_SLIDES_TO_END = 2;
class PublicationsSlider { 
    swiper

    constructor(el) {
        this.el = el;
        this.swiperWrap = this.el.querySelector(".swiper-wrapper");
        this.url = this.el.dataset.url;
        this.size = this.el.dataset.size;
        this.autoWidth = document.body.classList.contains("special_version");

        this.enableSlider();  
    }

    enableSlider() {
        let slidesPerView = 3;
        if (this.autoWidth) {
            slidesPerView = "auto";
        }
        this.swiper = new Swiper(this.el, {
            modules: [Navigation, Lazy],
            slidesPerView: "auto",
            preloadImages: false,
            watchSlidesProgress: true,
            spaceBetween: 8,
            observer: true,
            observeParents: true,
            createElements: true,
            followFinger: false,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 16,
                },
                [LG_WIDTH]: {
                    slidesPerView: slidesPerView,
                    spaceBetween: 16,
                }
            },
            navigation: {
                nextEl: ".js-publications-next",
                prevEl: ".js-publications-prev"
            },
            
            on: {
                slideChange: () => {
                    const length = this.swiper.slides.length;

                    if (this.swiper.visibleSlidesIndexes.includes(length - NUMBER_OF_SLIDES_TO_END)) {
                        getPublicationSlides(this.el, this.swiper, this.url, this.size);
                    }
                },
            },
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-publications-slider")
        .forEach(slider => new PublicationsSlider(slider));
});
